<template>
  <div class="content">
    <p>
      <i class="icon-ic_alert-red" />
      {{ mensagem }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    mensagem: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/styleguide';
.content {
  margin-top: 1rem;
  margin-bottom: 0;
  padding: 3.5%;
  width: 100%;
  border-radius: 0.25rem;
  background-color: rgba(233, 78, 14, 0.15);
  p {
    font-weight: $font-semi-bold;
    color: var(--orange-dark);
  }

  i {
    vertical-align: text-bottom;
  }
}
</style>
